module.exports = __webpack_public_path__ + "img/document-download.6dfd5eec.svg";